import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
	BehaviorSubject,
	Observable,
	Subject,
	catchError,
	of,
	tap,
} from "rxjs";
import { RequestPrompt } from "../../models/prompts";
import { AppHttpUtils } from "../appHttpUtils";
import { ToastService } from "../toast.service";
import { PromotionRequest } from "./../../models/promotion";

@Injectable({
	providedIn: "root",
})
export class PromptService {
	defaultHttpHeaders: HttpHeaders = new HttpHeaders();
	constructor(
		private http: HttpClient,
		private toastService: ToastService,
	) {
		this.defaultHttpHeaders.set("Content-Type", "application/json");
	}

	getPromopt(prompt: RequestPrompt) {
		return this.http
			.post(AppHttpUtils.getURL("/management/prompt"), prompt)
			.pipe(
				tap((data) => {
					return data;
				}),
				//   catchError()
			);
	}

	private handleError<T>(operation = "operation", result?: T) {
		return (error: any): Observable<T> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// Let the app keep running by returning an empty result.
			return of(result as T);
		};
	}

	private handleErrorWithToast<T>(operation = "operation", result?: T) {
		return (error: any): Observable<T> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// TODO: better job of transforming error for user consumption
			//   this.toastService.showErrorToast("Fail", error.error.errors ? error.error.errors : error.statusText
			//   );

			// Let the app keep running by returning an empty result.
			return of(result as T);
		};
	}
}
